import React from 'react';
import './GlobalLoading.css';
import logo from '../../images/logo.png';

export default function GlobalLoading() {
    return (
        <div className='globalLoadingContainer'>
            <div className='globalLoadingContent'>
                <div className='logoContainer'>
                    <img src={logo} alt="Logo" className='logoImage' />
                </div>
                <div className='loadingText'>
                    <h2>Cargando aplicación...</h2>
                    <div className='loadingBar'>
                        <div className='loadingProgress'></div>
                    </div>
                    <p>Preparando todo para ti</p>
                </div>
                <div className='loadingDots'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    );
}
